module.exports = __webpack_public_path__ + "static/media/meest-logo@3x.d11bb5ec.png";